import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../analyzeSlice";

export default function ActiveScenariosCheckbox() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const clearScenario=[];
	const { isActiveScenario,scenariosFullData,scenariosData,selectedScenarioName,selectedDataProductIds,customerList,selectedScenarioID } = state;

	function handleCheck(event) {
		dispatch(setState("isActiveScenario", !isActiveScenario));
		console.log("isActiveScenario", !isActiveScenario);
		dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("selectedScenarioID", ""));
		clearValues();
		
		if(!isActiveScenario)
		{
				const today=new Date();
				const todayStr=today.toISOString().split('T')[0];

				const activeScenario=scenariosFullData.filter(scenario=>{
					return todayStr>=scenario.effectiveStartDate && todayStr<=scenario.effectiveEndDate;
				});

				dispatch(setState("scenariosData",activeScenario));
		}
		else{
			dispatch(setState("scenariosData",scenariosFullData));
		}
	}

	const clearValues = () => {


		dispatch(setState("clearDataValues", true));
		dispatch(setState("scenariosData", clearScenario));
		dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("selectedScenarioID", ""));
		dispatch(setState("selectedDataCustomerIds", []));
		dispatch(setState("customerList", []));
		dispatch(setState("selectedDataProductIds", []));
		dispatch(setState("skuPgsData", []));
		dispatch(setState("customersData", []));


	}

	return (
		<Box
			sx={{
				width: 220,
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
			}}
		>
			<FormControlLabel
				control={
					<Checkbox
						checked={isActiveScenario}
						onChange={handleCheck}
						inputProps={{ "aria-label": "controlled" }}
						sx={{ mt: 0.3, mr: -2, }}
					/>
				}
				//override default margin
				sx={{ ml: 0, mr: 0 }}
			/>
			<Typography sx={{ mt: 1.5, transform: "translate(-20px, 0px)", }} >Active Scenarios Only</Typography>
		</Box>
	);
}
